module.exports = __webpack_public_path__ + "static/img/nopdf.ad458a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nopdf.jpg
// module id = dl3G
// module chunks = 18